module.exports = __webpack_public_path__ + "img/loading.142d7ab3.gif";